<template>
  <modal class="modal--confirm">
    <div class="modal__stage">
      <div class="modal__body">
        <div class="modal__panel">
          <div
            :class="`alert--${type}`"
            class="alert"
          >
            <div class="alert__panel">
              <div class="alert__icon">
                <i
                  :class="icon"
                  class="icon"
                />
              </div>
              <div class="alert__details">
                <h6>{{ title }}</h6>
                <!-- eslint-disable -->
                <div v-html="text" />
                <!-- eslint-enable -->
              </div>
            </div>
            <div class="alert__panel">
              <div class="button-group u-pos-r">
                <button
                  class="button button--light u-br"
                  @click.prevent="closeModal"
                >
                  Cancel
                </button>
                <button
                  :class="`button--${type}`"
                  class="button u-br"
                  @click.prevent="confirmAction"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@components/modals/Modal'

export default {
  name: 'ConfirmModal',
  components: {
    Modal,
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'icon-c-question',
    },
    type: {
      type: String,
      required: false,
      default: 'danger',
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    text: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    closeModal () {
      this.$store.dispatch('modal/close')
    },
    confirmAction () {
      this.$store.dispatch('modal/resolve')
    },
  },
}
</script>
